module.exports = __webpack_public_path__ + "6c4a0dbc/img/note-list-icon.961c1485.svg";